import styled from 'styled-components';

export const FormField = styled.div`
  margin-bottom: 1.5rem;
`;

export const StyledInput = styled.input`
  background: var(--grey-75);
  border: 1px solid var(--grey-300);
  border-radius: 6px;
  box-shadow: var(--shadow-inset-sm);
  box-sizing: border-box;
  font-family: var(--raleway);
  font-size: 13px;
  padding: 0.5rem 0.75rem;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;

  &:focus {
    border-color: var(--wbs-red);
    box-shadow:
      var(--shadow-inset-sm),
      0 0 0 2px rgba(200, 16, 46, 0.1);
    outline: none;
  }
`;

export const StyledTextarea = styled.textarea`
  background: var(--grey-75);
  border: 1px solid var(--grey-300);
  border-radius: 6px;
  box-shadow: var(--shadow-inset-sm);
  box-sizing: border-box;
  color: var(--grey-700);
  font-family: var(--raleway);
  font-size: 13px;
  min-height: 80px;
  padding: 0.5rem 0.75rem;
  resize: vertical;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
  width: 100%;

  &::placeholder {
    color: var(--grey-500);
  }

  &:focus {
    border-color: var(--wbs-red);
    box-shadow:
      var(--shadow-inset-sm),
      0 0 0 2px rgba(200, 16, 46, 0.1);
    outline: none;
  }
`;

export const Divider = styled.hr`
  background: var(--grey-300);
  border: none;
  height: 1px;
  margin: 2.5rem 0;
`;
